document.addEventListener("DOMContentLoaded", () => {

  function formatMoney(cents) {
    return "Rs. " + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    document.querySelectorAll("#cart-count").forEach(el => {
      el.textContent = cart.item_count;
    });

    const itemCountEl = document.getElementById("CartItemCount");
    if (itemCountEl) {
      itemCountEl.textContent = cart.item_count + (cart.item_count === 1 ? " item" : " items");
    }

    const subtotalEl = document.getElementById("CartSubtotal");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    const totalEl = document.getElementById("CartTotal");
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    cart.items.forEach(item => {
      const row = document.querySelector(`.cart-item[data-key="${item.key}"]`);
      if (!row) return;
      const input = row.querySelector(".qty-input");
      if (input) input.value = item.quantity;
      const priceEl = row.querySelector(".cart-item-price");
      if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
    });

    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  async function changeQuantity(key, quantity, btn) {
    if (btn) btn.disabled = true;
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const cart = await res.json();

      if (quantity === 0) {
        const row = document.querySelector(`.cart-item[data-key="${key}"]`);
        row?.remove();
      }

      renderCart(cart);
    } catch (e) {
      console.error("Cart update failed", e);
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  document.querySelectorAll(".qty-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const key = btn.dataset.key;
      const input = document.querySelector(`.qty-input[data-key="${key}"]`);
      if (!input) return;

      const current = parseInt(input.value || "0", 10);
      const next = btn.dataset.action === "plus" ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      changeQuantity(key, next, btn);
    });
  });

  document.querySelectorAll(".qty-input").forEach(input => {
    input.addEventListener("change", () => {
      const value = Math.max(0, parseInt(input.value || "0", 10));
      changeQuantity(input.dataset.key, value);
    });
  });

  const couponInput = document.getElementById("CouponCode");
  const applyBtn = document.getElementById("ApplyCoupon");
  const cartForm = document.getElementById("cart-form");

  applyBtn?.addEventListener("click", () => {
    if (!couponInput.value.trim()) return;
    applyBtn.textContent = "Applied at checkout";
  });

  cartForm?.addEventListener("submit", (e) => {
    const code = couponInput?.value.trim();
    if (code) {
      e.preventDefault();
      window.location.href = "/checkout?discount=" + encodeURIComponent(code);
    }
  });

});
